import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useStore from '../hooks/useStore'
import { computeUnstoppableStreak } from '../utils/streakUtils'

const FlameIcon = () => (
  <svg
    className="streak-flame"
    width="14" height="16" viewBox="0 0 14 18" fill="none"
    aria-hidden="true"
  >
    <path
      d="M7 1C7 1 11 5 11 9C11 12 9.5 13.5 8 14C8.5 12.5 8 11 7 10C6 11 5.5 12.5 6 14C4.5 13.5 3 12 3 9C3 5 7 1 7 1Z"
      fill="var(--primary)" opacity="0.9"
    />
    <path
      d="M7 8C7 8 8.5 10 8.5 12C8.5 13.5 7.8 14.5 7 15C6.2 14.5 5.5 13.5 5.5 12C5.5 10 7 8 7 8Z"
      fill="var(--primary2)"
    />
  </svg>
)

function Topbar() {
  const navigate = useNavigate()
  const menuRef = useRef(null)
  const [menuOpen, setMenuOpen] = useState(false)
  const { user, signOut, syncState, syncText, history } = useStore()

  const { currentStreak } = computeUnstoppableStreak(history)

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handlePointerDown)
    return () => document.removeEventListener('mousedown', handlePointerDown)
  }, [])

  const handleSignOut = async () => {
    try {
      await signOut()
      setMenuOpen(false)
      navigate('/auth')
    } catch (error) {
      console.error('Sign out error:', error)
    }
  }

  const handleFeedback = () => {
    setMenuOpen(false)
    navigate('/feedback')
  }

  if (!user) return null

  return (
    <header className="topbar">
      <div className="brand">
        <div className="brand-icon">R</div>
        <div>
          <div className="brand-name">Result<span>OS</span></div>
          <div className="brand-sub">The Unstoppable System</div>
        </div>
      </div>
      <div className="tb-center">
        <div className="live-dot"></div>
        <span>
          {new Date().toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          }).toUpperCase()}
        </span>
        {currentStreak >= 1 && (
          <span
            className="tb-streak"
            title={`Unstoppable streak: ${currentStreak} ${currentStreak === 1 ? 'day' : 'days'}`}
          >
            <FlameIcon />
            <span>{currentStreak}</span>
          </span>
        )}
      </div>
      <div className="tb-right">
        <div className="sync-row">
          <div className={`sync-dot ${syncState}`}></div>
          <span>{syncText}</span>
        </div>
        <div className="user-menu" ref={menuRef}>
          <button
            type="button"
            className={`user-chip ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
          >
            <div className="u-av">
              {user?.email?.[0]?.toUpperCase() || '?'}
            </div>
            <span>{user?.email?.split('@')[0] || '—'}</span>
            <span className="user-chip-caret">▾</span>
          </button>
          {menuOpen ? (
            <div className="user-dropdown" role="menu">
              <button type="button" className="user-dropdown-item" onClick={handleFeedback}>
                Feedback / Issues
              </button>
              <div className="user-dropdown-divider" />
              <button type="button" className="user-dropdown-item" onClick={handleSignOut}>
                Sign Out
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  )
}

export default Topbar
